import { render, staticRenderFns } from "./WorkingHours.vue?vue&type=template&id=2c5d3792&"
import script from "./WorkingHours.vue?vue&type=script&lang=js&"
export * from "./WorkingHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports